import Collapse from '@mui/material/Collapse';
import type { SystemStyleObject, Theme } from '@mui/system';
import type { ReactNode } from 'react';

const EXPAND_MS = 280;
const EXPAND_EASING = 'cubic-bezier(0.2, 0.85, 0.2, 1)';

const prefersReducedMotion = (): boolean =>
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

interface ExpandableProps {
  open: boolean;
  children: ReactNode;
}

export const Expandable = ({
  open,
  children,
}: ExpandableProps): JSX.Element => (
  <Collapse
    in={open}
    timeout={prefersReducedMotion() ? 0 : EXPAND_MS}
    unmountOnExit
    easing={{ enter: EXPAND_EASING, exit: EXPAND_EASING }}
  >
    {children}
  </Collapse>
);

export const expandableChevronSx = (
  open: boolean
): SystemStyleObject<Theme> => ({
  transition: `transform ${EXPAND_MS}ms ${EXPAND_EASING}`,
  transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
  '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
});
